import { ComponentUtilities } from './../shared/component.utilities';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { User } from './../unsplash/unsplash.response';
import { AuthService } from './../user/auth.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { ISubscription } from "rxjs/Subscription";

@Component({
  selector: 'app-signin',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  hitchdForm: FormGroup;
  subscription: ISubscription;
  errorMessage: string;
  reset = false;
  submitting = false;
  verified = false;
  emailSet = false;
  constructor(public _authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _fb: FormBuilder,
    private _validatorService: CustomValidatorsService,
    private componentUtils: ComponentUtilities

  ) {

  }


  blurEmail() {
    this.emailSet = true;
  }
  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }


  ngOnInit() {
    this.hitchdForm = this._fb.group({
      email: ['', [Validators.required, Validators.email]],

    });
    this.componentUtils.hideLoader();

  }


  submit() {
    this.errorMessage = '';
    this.submitting = true;
    if (this.hitchdForm.valid) {
      const email = this.hitchdForm.controls['email'].value;

      (window as any ).grecaptcha.execute('6LeRGRUpAAAAAE7lY2q9SzI3OjafICtmjTzPEPyc', {action: 'submit'}).then((token)=> {

        ;
        this._authService.forgotPassword(email, token);
        this.reset = true;
           });


      
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts